<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      sort-by="name"
      :search="search"
      class="elevation-0 general-table"
      :loading="isLoading"
      @click:row="itemEdit"
      :loading-text="$t('GLOBAL-LOADING-PLEASE_WAIT')"
    >
      <template v-slot:header.name="{ header }">
        <lang t="BUNDLE_GROUPS-TBL-HEADER-NAME"></lang>
      </template>

      <template v-slot:header.level="{ header }">
        <lang t="BUNDLE_GROUPS-TBL-HEADER-LEVEL"></lang>
      </template>

      <template v-slot:header.bundleCount="{ header }">
        <lang t="BUNDLE_GROUPS-TBL-HEADER-BUNDLE_COUNT"></lang>
      </template>

      <template v-slot:top>
        <div class="d-flex align-center flex-wrap py-2 mb-3">
          <v-text-field
            clearable
            class="general-table__search"
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            :label="$t('GLOBAL-DO_SEARCH')"
            solo
            flat
            dense
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <Button type="outside-label" icon="mdi-plus" :label="$t('PACKAGING_CLASSES-BTN-NEW_BUNDLE_GROUP')" @click="itemAdd" />
        </div>
      </template>

      <template v-slot:item.name="{ item }">
        {{ item.name }}
      </template>

      <template v-slot:item.level="{ item }">
        <SimpleChip auto-width :name="item.level" small default-icon="" readonly></SimpleChip>
       
      </template>

      <template v-slot:item.bundleCount="{ item }">
        <display-number :number="item.bundleCount" />
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="pa-1"
          color="grey darken-2"
          @click.stop.prevent="itemEdit(item)"
          >mdi-pencil</v-icon
        >
        <v-icon
          small
          class="pa-1"
          color="grey darken-2"
          @click.stop.prevent="itemDelete(item)"
          :disabled="item.bundleCount > 0"
          >mdi-delete</v-icon
        >
      </template>

      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">{{ $t("Reset") }}</v-btn>
      </template>

      <template v-slot:footer.page-text="props" v-if="(items.length > 0)">
        <display-number :number="props.pageStart" />-<display-number :number="props.pageStop" /> {{ $t("of") }}
        <display-number :number="items.length" />
      </template>


    </v-data-table>



    <v-dialog v-model="dialog.show" max-width="640px" :persistent="false">
      <v-card>
        <v-card-title>
          <span class="title1"><lang :t="dialog.title"></lang></span>
        </v-card-title>

        <v-card-text>
          <v-text-field
            :label="$t('BUNDLE_GROUPS-NAME')"
            v-model="editedItem.name"
          ></v-text-field>

          <BoxItem
                    :title="$t('BUNDLE-GROUPS-LEVEL')"
                    :value="editedItem.level"
                    :items="levels"
                    itemsValue="value"
                    itemsText="text"
                    @updateValue="editedItem.level = $event"
                  />  
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeModal" :disabled="dialog.isSaving"
            ><lang t="GLOBAL-BTN-CANCEL"></lang
          ></v-btn>
          <v-btn
            elevation="0"
            class="general-action-btn"
            :loading="dialog.isSaving"
            @click="itemSave()"
            ><lang t="GLOBAL-BTN-SAVE"></lang
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Button from '../../../components/ui-elements/Button.vue';
import DisplayNumber from '../../../components/DisplayNumber.vue';
import BoxItem from '../../../components/ui-elements/BoxItem.vue';
import SimpleChip from '../../../components/ui-elements/SimpleChip.vue';
export default {
  name: 'BundleGroupsIndex',
  components:{
    Button,
    DisplayNumber,
    BoxItem,
    SimpleChip
  },
  data: () => ({
    isSaving: false,
    isLoading: true,
    search: "",
    headers: [
      { text: "Name", align: "start", value: "name", sortable: true, class: 'general-table__th--3' },
      { text: "Level", align: "start", value: "level", sortable: true, class: 'general-table__th--3' },
      { text: "Count", align: "start", value: "bundleCount", sortable: true, class: 'general-table__th--3' },
      { text: "", value: "actions", sortable: false, width: "80px" },
    ],

    items: [],

    dialog: {
      show: false,
      title: "",
      isSaving: false,
    },

    editedIndex: -1,

    editedItem: {
      name: null,
      level: 'case'
    },

    defaultItem: {
      name: null,
      level: 'case'
    },
  }),

  watch: {
    "dialog.show"(val) {
      val || this.closeModal();
    },
  },

  computed: {
    levels(){
      return [
        {value: 'case', text: this.$t('ARTICLE-BUNDLE-CASE-TITLE')},
        {value: 'pack', text: this.$t('ARTICLE-BUNDLE-PACK-TITLE')},
        {value: 'unit', text: this.$t('ARTICLE-BUNDLE-UNIT-TITLE')},
      ]; 
    }
  },

  created() {
    this.initialize();
  },

  mounted() {},

  methods: {
    closeModal(refresh = false) {
      this.dialog.show = false;
      this.dialog.fullscreen = false;
      this.itemsSelected = [];
      this.isSaving = false;

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });

      if (refresh === true) {
        this.initialize();
      }
    },

    initialize() {
      this.isLoading = true;
      this.axios.get("bundlegroups").then((res) => {
        this.items = res.data;
        this.isLoading = false;
      });
    },

    itemDelete(item) {
      this.$confirm(
        this.$t("GLOBAL-CONFIRMATION-DELETE-MSG", { NAME: item.name }),
        {
          title: this.$t("GLOBAL-CONFIRMATION-DELETE-TITLE"),
          buttonTrueText: this.$t("GLOBAL-CONFIRMATION-DELETE-YES"),
          buttonFalseText: this.$t("GLOBAL-CONFIRMATION-DELETE-CANCEL"),
        }
      ).then((res) => {
        if (res) {
          this.axios.delete("bundlegroups/" + item.id).then((res) => {
            this.initialize();
            this.$store.dispatch("setSnackbar", {
              text: this.$t("GLOBAL-SUCCESSFULLY_DELETED"),
            });
          });
        }
      });
    },
    rowClick(item) {
      this.itemEdit(item);
    },

    itemEdit(item) {
      this.$router.push({
        name: "settings-bundle_groups-detail",
        params: { id: item.id, item: item },
      });
    },

    itemAdd() {
      this.dialog.title = this.$t("BUNDLE_GROUPS-NEW_BUNDLE_GROUP");
      this.dialog.maxSize = "640";

      this.dialog.show = true;
    },

    itemSave() {
      this.dialog.isSaving = true;

      if (this.editedIndex == -1) {
        this.axios
          .post("bundlegroups", this.editedItem)
          .then((res) => {
            this._fin();
          })
          .catch((err) => {
            this.dialog.isSaving = false;
            this.$store.dispatch("setSnackbar", {
              text:
                this.$t("GLOBAL-MESSAGE-ERROR") +
                ": " +
                err.response.data.message,
              type: "error",
            });
          });
      } else {
        this.axios
          .put("bundlegroups/" + this.editedItem.id, this.editedItem)
          .then((res) => {
            this._fin();
          })
          .catch((err) => {
            this.dialog.isSaving = false;
            this.$store.dispatch("setSnackbar", {
              text:
                this.$t("GLOBAL-MESSAGE-ERROR") +
                ": " +
                err.response.data.message,
              type: "error",
            });
          });
      }
    },

    _fin() {
      this.dialog.isSaving = false;
      this.$store.dispatch("setSnackbar", {
        text: this.$t("GLOBAL-MESSAGE-SUCCESSFULLY_SAVED"),
      });
      this.initialize();
      this.closeModal();
    },

  
  },
};
</script>

<style lang="scss">
tbody > tr {
  cursor: pointer;
}
</style>
